import { useEffect, useReducer } from 'react';
import { API } from '../../api/api';
import { URLS } from '../../api/urls';
import { actionPageTypes } from './reducer/reducer.type';
import { BannersDTO } from './types';
import { useAlert } from '../../context/Alert.context';
import { initialState, reducer } from './reducer/reducer';
import { ModalKeys } from './chooseModal';

export const useBannersPage =  () => {
  const [{ banners, loading, choosenModal, selectedBanner }, dispatch] = useReducer(
    reducer,
    initialState,
  );
  const { showAlert } = useAlert();
  useEffect(() => {
    API.get<BannersDTO[]>(`${URLS.BANNERS}`)
      .then(({ data }) => {
        dispatch({ type: actionPageTypes.SET_BANNERS, payload: data });
      })
      .catch((e) => showAlert({ message: e.message, severity: 'error' }))
      .finally(() =>
        dispatch({ type: actionPageTypes.SET_LOADING, payload: false }),
      );
  }, []);

  const actions = {
    setSelectedPage: (page: BannersDTO | null) =>
      dispatch({
        type: actionPageTypes.SET_SELECTED_BANNER,
        payload: page,
      }),
    setModal: (value: ModalKeys | null) =>
      dispatch({ type: actionPageTypes.SET_CHOOSEN_MODAL, payload: value }),
    closeModal: () =>
      dispatch({ type: actionPageTypes.SET_CHOOSEN_MODAL, payload: null }),
  };

  const updateBannerAfterDelete = () => {
    const updatedBanners: BannersDTO[] = banners.filter(
      (banner: BannersDTO) => banner.id !== selectedBanner?.id,
    );
    dispatch({ type: actionPageTypes.SET_BANNERS, payload: updatedBanners });
  };

  const updateBannerAfterEdit = (banner: BannersDTO) => {
    const updatedBanners = banners.map((item) => {
      if (item.id === banner?.id) {
        return {
          ...banner,
        };
      }
      return item;
    });
    dispatch({ type: actionPageTypes.SET_BANNERS, payload: updatedBanners });
  };

  const updateBannerAfterCreate = (banner: BannersDTO) => {
    const updatedBanners: BannersDTO[] = [...banners, banner];
    dispatch({ type: actionPageTypes.SET_BANNERS, payload: updatedBanners });
  };

  return {
    loading,
    banners,

    updateBannerAfterDelete,
    updateBannerAfterCreate,
    updateBannerAfterEdit,
    choosenModal,
    selectedBanner,
    ...actions
  }
}